// Bezeichnungen der Auswertungen für Server (CSV, Kacheln) UND Oberfläche. Kein Wort hier setzt eine Branche voraus:
// Einheiten, Warengruppen und Kundengruppen kommen aus den Stammdaten des Betriebs.

export const SALES_CHANNELS = ['pos', 'delivery', 'app'] as const
export type SalesChannel = (typeof SALES_CHANNELS)[number]
export const CHANNEL_LABELS: Record<SalesChannel, string> = { pos: 'Kasse', delivery: 'Auftrag und Lieferung', app: 'Online-Bestellung' }

export const SALES_GROUPINGS = ['day', 'week', 'month', 'location', 'channel', 'itemGroup', 'item', 'customer', 'customerGroup'] as const
export type SalesGrouping = (typeof SALES_GROUPINGS)[number]
export const SALES_GROUPING_LABELS: Record<SalesGrouping, string> = {
  day: 'Tag',
  week: 'Woche',
  month: 'Monat',
  location: 'Standort',
  channel: 'Vertriebsweg',
  itemGroup: 'Warengruppe',
  item: 'Artikel',
  customer: 'Kunde',
  customerGroup: 'Kundengruppe',
}

export const STOCK_GROUPINGS = ['location', 'itemGroup', 'item'] as const
export type StockGrouping = (typeof STOCK_GROUPINGS)[number]
export const STOCK_GROUPING_LABELS: Record<StockGrouping, string> = { location: 'Standort', itemGroup: 'Warengruppe', item: 'Artikel' }

export const SHRINKAGE_GROUPINGS = ['reason', 'location', 'month', 'item'] as const
export type ShrinkageGrouping = (typeof SHRINKAGE_GROUPINGS)[number]
export const SHRINKAGE_GROUPING_LABELS: Record<ShrinkageGrouping, string> = { reason: 'Grund', location: 'Standort', month: 'Monat', item: 'Artikel' }

/** Ansichten der Startseite. Welche eine Person sieht, folgt ihren Rechten – nicht dem Namen ihrer Rolle. */
export const DASHBOARD_PROFILES = ['management', 'store', 'purchasing', 'finance', 'warehouse'] as const
export type DashboardProfile = (typeof DASHBOARD_PROFILES)[number]
export const DASHBOARD_PROFILE_LABELS: Record<DashboardProfile, string> = {
  management: 'Geschäftsführung',
  store: 'Filiale',
  purchasing: 'Einkauf',
  finance: 'Buchhaltung',
  warehouse: 'Lager',
}

export const WEEKDAY_LABELS = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'] as const
export const WEEKDAY_SHORT = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'] as const

/** Belegarten, die Umsatz tragen – mit Vorzeichen: Rechnungskorrektur und Kassenrücknahme mindern ihn. */
export const REVENUE_DOCUMENT_TYPES = ['invoice', 'credit_note', 'pos_receipt', 'pos_return'] as const
export const REVENUE_TYPE_LABELS: Record<string, string> = {
  invoice: 'Rechnung',
  credit_note: 'Rechnungskorrektur',
  pos_receipt: 'Kassenbon',
  pos_return: 'Rücknahme an der Kasse',
}

/** Bewegungsarten des Schwunds: Korrekturbuchungen und gebuchte Inventurdifferenzen. */
export const SHRINKAGE_SOURCE_LABELS: Record<string, string> = { adjustment: 'Korrekturbuchung', count: 'Inventurdifferenz' }

export const NO_GROUP_LABEL = 'Ohne Warengruppe'
export const NO_CUSTOMER_GROUP_LABEL = 'Ohne Kundengruppe'
export const NO_CUSTOMER_LABEL = 'Ohne Kunde (Barverkauf)'
export const NO_ITEM_LABEL = 'Ohne Artikel (Nachlass, Gebühr)'
export const NO_REASON_LABEL = 'Ohne Grund'

export const MONTH_LABELS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'] as const

/** „Oktober 2026“ aus einem Tag des Monats ('YYYY-MM-DD'). */
export const monthLabel = (date: string): string => `${MONTH_LABELS[Number(date.slice(5, 7)) - 1] ?? date.slice(5, 7)} ${date.slice(0, 4)}`
